import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=43a6499e"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports